import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {CustomerService} from './customer.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public customerService: CustomerService, public router: Router) {
  }

  canActivate(): Promise<boolean> {
    return this.customerService.getCurrentUser()
      .then(user => {
        if (user) return true;
        else {
          this.router.navigate(['/']);
          return false;
        }
      })
      .catch(_ => {
        return false;
      });

  }

}
